import { isPlatform } from '@ionic/react';
import { addPro, addProBackend, removeProBackend } from './logInActions';
import { goToPage, goToPageWithState } from './../../helpers/app_actions';
import { subscriptionId, } from './../../helpers/shop_helper';
import { SET_PRO, SET_STORE } from '../constants/index'
// import { IAPProduct, IAPError, InAppPurchase2 as Store } from "@awesome-cordova-plugins/in-app-purchase-2";
import store from '../store'
import "cordova-plugin-purchase"
import { initializeStore } from '../../helpers/shop_helper_2';

declare interface Window { store: CdvPurchase.Store; }

const Store: CdvPurchase.Store = window.store
const state = store.getState()

export const setPRO = (payload: any) => {
  return {
    type: SET_PRO,
    payload
  }
}

export const setSTORE = (payload: any) => {
  return {
    type: SET_STORE,
    payload
  }
}

export const initiateStore = async (wtteams: boolean) => {
  return new Promise((resolve, reject) => {
    initializeStore().then(res => {
      resolve(true)
    }).catch(e => reject(false))
  })

  // return new Promise((resolve, reject) => {
  // Store.validator = 'https://validator.fovea.cc/v1/validate?appName=wt&apiKey=d3eb0a3f-5aae-4c7b-b87b-633dd2207831'
  // Store.verbosity = CdvPurchase.LogLevel.QUIET;
  // Store.register({
  //   platform: isPlatform('android') ? CdvPurchase.Platform.GOOGLE_PLAY : CdvPurchase.Platform.APPLE_APPSTORE,
  //   id: subscriptionId(),
  //   type: CdvPurchase.ProductType.PAID_SUBSCRIPTION,
  // });

  // // Register event handlers for the specific product
  // Store.when().registered( (product: CdvPurchase.Product) => {
  // });

  // const product = Store.get(subscriptionId()) as CdvPurchase.Product
  //   // console.log('Proaction: loaded: ' + JSON.stringify(product))
  //   const data = {
  //     loading: false,
  //     title: product.title,
  //     description: product.description,
  //     price: product.pricing ? product.pricing.price : undefined,
  //     currency: product.pricing ? product.pricing.currency : undefined,
  //     owned: product.owned,
  //     type: product.type,
  //     // expiryDate: product.expiryDate,
  //     // lastRenewalDate: product.lastRenewalDate,
  //   }
  //   store.dispatch(setPRO(data))


  // Updated
  // Store.when().productUpdated((product: CdvPurchase.Product) => {
  // })

  // Store.when().cancelled((product: CdvPurchase.Product) => {
  //   store.dispatch(setPRO({...state.store, loading: false}))
  // });
  
  // Store.when().error((e: CdvPurchase.IError) => {
  //     goToPage('/walk/shop/error')
  //     store.dispatch(setPRO({...state.store, loading: false}))
  // });

  // Store.when().owned((product: CdvPurchase.Product) => {
  //   const state2 = store.getState()
  //   if(isPlatform('android')) {
  //     if(product.owned && state2.logIn.user.WTTeams === false) {
  //       addProBackend()
  //     }
  //   } else {
  //     if(product.owned && state2.logIn.user.WTTeams === false) {
  //       addProBackend()
  //       resolve(true)
  //     } else if(product.owned) {
  //       store.dispatch(addPro(true))
  //       resolve(true)
  //     } else {
  //       store.dispatch(addPro(false))
  //       resolve(false)
  //     }
  //   }
  // })

  // Store.when().expired((product: CdvPurchase.Product) => {
  //   const state2 = store.getState()
  //   store.dispatch(addPro(false))
  //   goToPage('/walk/shop/expired')
  //   removeProBackend(state2.logIn.user.WTTeamsPurchaseId)
  //   resolve(false)
  // })

  // Store.when().error((e: CdvPurchase.IError) => {
  //   goToPageWithState('/walk/shop/error', e.message)
  //   store.dispatch(setPRO({...state.store, loading: false}))
  //   resolve(false)
  // })

  // Store.error((e: any) => {
  //   goToPageWithState('/walk/shop/error', e.message)
  //   store.dispatch(setPRO({...state.store, loading: false}))
  //   resolve(false)
  // });

  // Store.when().initiated(() => {
  //   store.dispatch(setPRO({...state.store, loading: true}))
  // });

  // Store.when().unverified((unverifiedReceipt: CdvPurchase.UnverifiedReceipt) => {
  // })

  // Store.when().approved((transaction: CdvPurchase.Transaction) => {
  //   transaction.verify()

  // }).verified((product: any) => {
  //   if(product.owned || product.state === 'approved') {
  //     product.finish()  
  //   } else {
  //     resolve(false)
  //   }  
  // }).finished((product: any) => {
  //   console.log('product finished*****')
  // })

  // Store.ready(() =>  {
  //   store.dispatch(setSTORE(true))
  //   if(Store.get(subscriptionId())) {
  //     resolve(Store.get(subscriptionId())?.owned)
  //   }
  // });

  // Store.initialize();
  // })
}

